import React, { useState } from 'react';

const CalculatorContent = ({ scenario, onComplete }) => {
  const [display, setDisplay] = useState('0');
  const [previousValue, setPreviousValue] = useState(null);
  const [operation, setOperation] = useState(null);
  const [waitingForOperand, setWaitingForOperand] = useState(false);

  const inputDigit = (digit) => {
    if (waitingForOperand) {
      setDisplay(String(digit));
      setWaitingForOperand(false);
    } else {
      setDisplay(display === '0' ? String(digit) : display + digit);
    }
  };

  const inputDecimal = () => {
    if (waitingForOperand) {
      setDisplay('0.');
      setWaitingForOperand(false);
    } else if (display.indexOf('.') === -1) {
      setDisplay(display + '.');
    }
  };

  const clear = () => {
    setDisplay('0');
    setPreviousValue(null);
    setOperation(null);
    setWaitingForOperand(false);
  };

  const performOperation = (nextOperation) => {
    const inputValue = parseFloat(display);

    if (previousValue === null) {
      setPreviousValue(inputValue);
    } else if (operation) {
      const currentValue = previousValue || 0;
      const newValue = calculate(currentValue, inputValue, operation);

      setDisplay(String(newValue));
      setPreviousValue(newValue);
    }

    setWaitingForOperand(true);
    setOperation(nextOperation);
  };

  const calculate = (firstValue, secondValue, operation) => {
    switch (operation) {
      case '+':
        return firstValue + secondValue;
      case '-':
        return firstValue - secondValue;
      case '×':
        return firstValue * secondValue;
      case '÷':
        return secondValue !== 0 ? firstValue / secondValue : 0;
      default:
        return secondValue;
    }
  };

  const equals = () => {
    const inputValue = parseFloat(display);

    if (previousValue !== null && operation) {
      const newValue = calculate(previousValue, inputValue, operation);
      setDisplay(String(newValue));
      setPreviousValue(null);
      setOperation(null);
      setWaitingForOperand(true);
    }
  };

  const toggleSign = () => {
    const value = parseFloat(display);
    setDisplay(String(value * -1));
  };

  const percentage = () => {
    const value = parseFloat(display);
    setDisplay(String(value / 100));
  };

  const Button = ({ children, onClick, className = '', span = false }) => (
    <button
      onClick={onClick}
      className={`${span ? 'col-span-2' : 'aspect-square'} text-xl font-medium rounded hover:opacity-80 transition-opacity ${className}`}
    >
      {children}
    </button>
  );

  return (
    <div className="h-full flex flex-col bg-gray-900 text-white p-3">
      {/* Display */}
      <div className="mb-3 p-4 bg-black rounded text-right">
        <div className="text-3xl font-light overflow-x-auto whitespace-nowrap">
          {display}
        </div>
      </div>

      {/* Calculator Buttons */}
      <div className="grid grid-cols-4 gap-2 flex-1 content-start">
        {/* Row 1 */}
        <Button onClick={clear} className="bg-gray-600">C</Button>
        <Button onClick={toggleSign} className="bg-gray-600">±</Button>
        <Button onClick={percentage} className="bg-gray-600">%</Button>
        <Button onClick={() => performOperation('÷')} className="bg-orange-500">÷</Button>

        {/* Row 2 */}
        <Button onClick={() => inputDigit(7)} className="bg-gray-700">7</Button>
        <Button onClick={() => inputDigit(8)} className="bg-gray-700">8</Button>
        <Button onClick={() => inputDigit(9)} className="bg-gray-700">9</Button>
        <Button onClick={() => performOperation('×')} className="bg-orange-500">×</Button>

        {/* Row 3 */}
        <Button onClick={() => inputDigit(4)} className="bg-gray-700">4</Button>
        <Button onClick={() => inputDigit(5)} className="bg-gray-700">5</Button>
        <Button onClick={() => inputDigit(6)} className="bg-gray-700">6</Button>
        <Button onClick={() => performOperation('-')} className="bg-orange-500">−</Button>

        {/* Row 4 */}
        <Button onClick={() => inputDigit(1)} className="bg-gray-700">1</Button>
        <Button onClick={() => inputDigit(2)} className="bg-gray-700">2</Button>
        <Button onClick={() => inputDigit(3)} className="bg-gray-700">3</Button>
        <Button onClick={() => performOperation('+')} className="bg-orange-500">+</Button>

        {/* Row 5 */}
        <Button onClick={() => inputDigit(0)} className="bg-gray-700" span>0</Button>
        <Button onClick={inputDecimal} className="bg-gray-700">.</Button>
        <Button onClick={equals} className="bg-orange-500">=</Button>
      </div>
    </div>
  );
};

export default CalculatorContent;

